import {
  IsNotEmpty,
  IsArray,
  IsOptional,
  ValidateNested,
  IsBoolean,
  IsDate,
  IsIn,
} from "class-validator";
import { Type } from "class-transformer";

import { IQuery, QueryDto } from "../query";
import { IAdapterFolderProgressSummaryAction } from "./adapter-folder-progress-summary-action.interface";

export class AdapterFolderProgressSummaryActionDto implements IAdapterFolderProgressSummaryAction {
  @IsNotEmpty()
  folder_id: string;

  @IsOptional()
  baseline_id: string | null;

  @IsBoolean()
  exclude_references: boolean = true;

  @IsNotEmpty()
  @IsIn(["workorder", "operation"])
  entity_name: string = "operation";

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: IQuery;

  @IsDate()
  @IsOptional()
  start_date?: Date;

  @IsDate()
  @IsOptional()
  end_date?: Date;
}
